import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CrmService } from 'src/home/crm/services/crm.service';
import { HomeService } from 'src/home/home.service';
import { Client } from 'src/models/Client.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent {

  clientForm!: FormGroup;
  isLoading: boolean = false;

  constructor(private fb: FormBuilder, private homeService: HomeService, private crmService: CrmService) {

    this.clientForm = this.fb.group({
      cif: ['', Validators.required],
      delegation: ['', Validators.required],
      clientCode: [0, Validators.required],
      socialReason: ['', Validators.required],
      name: ['', Validators.required],
      fiscalAddress: ['', Validators.required],
      fiscalPortalCode: ['', Validators.required],
      fiscalCity: ['', Validators.required],
      fiscalProvince: ['', Validators.required],
      fiscalCountry: ['', Validators.required],
      billAddress: ['', Validators.required],
      billPostalCode: ['', Validators.required],
      billCity: ['', Validators.required],
      billProvince: ['', Validators.required],
      billCountry: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      billContact: ['']
    });
  }

  handleCreateClient(): void {
    if (this.clientForm.valid) {
      const newClient: Client = {
        cif: this.clientForm.get('cif')?.value,
        delegation: this.clientForm.get('delegation')?.value,
        clientCode: this.clientForm.get('clientCode')?.value,
        socialReason: this.clientForm.get('socialReason')?.value,
        name: this.clientForm.get('name')?.value,
        fiscalAddress: this.clientForm.get('fiscalAddress')?.value,
        fiscalPortalCode: this.clientForm.get('fiscalPortalCode')?.value,
        fiscalCity: this.clientForm.get('fiscalCity')?.value,
        fiscalProvince: this.clientForm.get('fiscalProvince')?.value,
        fiscalCountry: this.clientForm.get('fiscalCountry')?.value,
        billAddress: this.clientForm.get('billAddress')?.value,
        billPostalCode: this.clientForm.get('billPostalCode')?.value,
        billCity: this.clientForm.get('billCity')?.value,
        billProvince: this.clientForm.get('billProvince')?.value,
        billCountry: this.clientForm.get('billCountry')?.value,
        email: this.clientForm.get('email')?.value,
        billContact: this.clientForm.get('billContact')?.value
      }
      if (newClient) {
        this.isLoading = true;
        this.crmService.createClient(newClient).subscribe(
          () => {
            console.log('creando cliente');
            this.isLoading = false;
            Swal.fire({
              text: 'Cliente creado exitosamente',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#4caf50'
            });
            this.clientForm.reset();
          },
          (error) => {
            this.isLoading = false;
            Swal.fire({
              text: 'Error al crear el cliente',
              icon: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: '#f44336'
            })
          }
        )
        this.clientForm.reset();
      }
    }
  }
}





// onSubmit(): void {
//   if (this.clientForm.valid) {
//     const clientData: Client = this.clientForm.value;

//     Swal.fire({
//       title: 'Confirmar creación',
//       text: '¿Está seguro que desea crear este nuevo cliente?',
//       icon: 'question',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Sí, crear cliente',
//       cancelButtonText: 'Cancelar'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         this.homeService.createClient(clientData)
//           .subscribe(
//             () => {
//               Swal.fire({
//                 title: '¡Éxito!',
//                 text: 'Cliente creado exitosamente.',
//                 icon: 'success',
//                 confirmButtonColor: '#3085d6',
//               });
//               this.resetForm();
//             },
//             (error) => {
//               Swal.fire({
//                 title: 'Error',
//                 text: 'Ha ocurrido un error al crear el cliente.',
//                 icon: 'error',
//                 confirmButtonColor: '#d33',
//               });
//             }
//           );
//       }
//     });
//   } else {
//     Swal.fire({
//       title: 'Formulario inválido',
//       text: 'Por favor, complete correctamente el formulario antes de enviar.',
//       icon: 'error',
//       confirmButtonColor: '#d33',
//     });
//   }
// }




